<template>
  <div class="btnDashboard"  :style="{'margin-top': marginTop,'margin-right': marginRight}" style="margin-left: -7px;">
    <a @click="dashboard" target="_self">
        <div style="display: flex;flex-direction:row;justify-content: center;align-items: center;overflow: auto;" slot="reference">
          <div class="btnIcon" :style="{'color': color}" style="display: flex;flex-direction:row;justify-content: center;align-items: center">
            <svg-icon icon-class="dashboard"  class-name='left-menu-logo' style="margin-right: 5px"/>
          </div>
          <div class="btnTitle" :style="{'color': color}" >{{$t("route.dashboard")}}</div>
          <!--<i class="el-icon-caret-bottom" :style="{'color': color}"></i>-->
        </div>
    </a>
  </div>
</template>

<script>
  import {recordBehaviorsAfter} from "../../../monitoring/performanceMonitoring";
  import $router from '@/router'
  export default {
    name: "dashboard",
    props: {
      marginTop: {
        type: String,
        default:'0px'
      },
      marginRight: {
        type: String,
        default:'0px'
      },
      color: {
        type: String,
        default:'#ffffff'
      },
    },
    data() {
      return{

      }
    },
    methods: {
      dashboard(){
        recordBehaviorsAfter($router.history.current).then((res) => {
          if(res.jsonBody.rtnCode == 0){
            window.location.href="/dashboard/index"
          }else{
            this.$message({
              message: res.jsonBody.msg,
              type: 'error',
              duration: 1000
            })
          }
        }).catch(err => {
          console.log('err',err)
        });
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .btnDashboard{
    min-width: 100px;
    display: inline-block;
    text-align: right;
    /*margin-right: 10px;*/
    line-height: 40px;
    cursor: pointer;
    .btnIcon{
      height: 40px;
      /* width: 40px; */
      line-height: 75px;
      color:rgba(255,255,255,1);
      font-size: 24px;
    }
    .btnTitle{
      font-size:14px;
      font-family:inter;
      font-weight:700;
      color:rgba(255,255,255,1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Dashboard.vue